export default __webpack_public_path__ + "static/media/N_Navio.6395f562.svg";